/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, ClassNames } from '@emotion/react'
import { TablePropGetter, TableProps } from 'react-table'
import cn from 'classnames'
import { ReactNode } from 'react'

interface Props<D extends object> {
  children: ReactNode
  className?: string
  getTableProps: (propGetter?: TablePropGetter<D>) => TableProps
}

export default function Table<D extends object>({ children, className, getTableProps }: Props<D>) {
  const { style, className: tablePropsClassName, ...restOfProps } = getTableProps()
  return (
    <ClassNames>
      {({ css, cx }) => (
        <div
          {...restOfProps}
          className={cn(tablePropsClassName, className, 'VfTable')}
          css={cx(
            // @ts-ignore
            css(style),
            css`
              height: 100%;
            `
          )}
        >
          {children}
        </div>
      )}
    </ClassNames>
  )
}
